import { render, staticRenderFns } from "./EpochDetail.vue?vue&type=template&id=3e8ab92e&"
import script from "./EpochDetail.vue?vue&type=script&lang=js&"
export * from "./EpochDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports